import React, { useState, useEffect } from "react";
import { FaComments, FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import { FaArrowUpLong } from "react-icons/fa6";
import "./scrollButton.css"; // CSS file for styling
import { Link } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import { useDashBoardData } from "../../context/dashboardDataContext/DashboardDataContext";

const ScrollToTopButton = () => {
  const { contactInfo } = useDashBoardData();
  const [openChatBox, setOpenChatBox] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  const handleOpenChatBox = () => {
    setOpenChatBox(!openChatBox);
  };

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const totalHeight = documentHeight - windowHeight;

      if (totalHeight > 0) {
        const progress = (scrollTop / totalHeight) * 100;
        setScrollProgress(progress);
      }

      setShowButton(scrollTop > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      {showButton && (
        <button
          // className={
          //   isSticky
          //     ? `${style.top_navbar_main} sticky`
          //     : `${style.top_navbar_main}`
          // }
          className={
            !openChatBox
              ? "scroll-to-top-btn"
              : "scroll-to-top-btn scroll-to-top-btn-open-chat"
          }
          onClick={scrollToTop}
        >
          <FaArrowUpLong />
          {/* <div className="scroll-top">
            <svg
              className="progress-circle svg-content"
              viewBox="-1 -1 102 102"
             style={{height:"100%",width:"100%"}}
            >
              <path
                d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
                style={{
                  transition:"stroke-dashoffset 10ms linear 0s",
                  strokeDasharray:"307.919, 307.919",
                  strokeDashoffset: `${scrollProgress}`,
                }}
              />
            </svg>
          </div> */}
        </button>
      )}
      <div className="chat_with_us_box">
        {openChatBox && (
          <>
            <div className="open_chat_box_menu">
              <Link
                to={`tel:${contactInfo?.contact_us?.mobile}`}
                className="c_w_phone_btn"
              >
                <FaPhoneAlt />
              </Link>
              <Link
                to={`https://api.whatsapp.com/send?phone=${contactInfo?.contact_us?.mobile}`}
                target="_blank"
                className="c_w_whatsapp_btn"
              >
                <FaWhatsapp />
              </Link>
            </div>
          </>
        )}
        <div className="c_w_comment_btn" onClick={handleOpenChatBox}>
          {!openChatBox ? <FaComments /> : <IoClose />}
        </div>
      </div>
    </div>
  );
};

export default ScrollToTopButton;
